import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import Seo from '../components/Seo';
import { FiArrowLeft, FiHelpCircle } from 'react-icons/fi';

const notFoundSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Page not found | LearnWebCare',
  description: 'The requested page could not be found on LearnWebCare.',
};

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Seo
        title="Page not found | LearnWebCare"
        description="The page you requested does not exist. Return to the homepage or browse frequently asked questions."
        canonicalUrl="https://learnwebcare.com/404"
        ogTitle="Page not found | LearnWebCare"
        ogDescription="The page you requested does not exist."
        ogUrl="https://learnwebcare.com/"
        ogImage="https://learnwebcare.com/logo.webp"
        schema={notFoundSchema}
        noIndex
      />
      <Header />

      <main className="flex-1 relative overflow-hidden bg-slate-50">
        <div className="absolute inset-x-0 top-0 h-[320px] bg-[radial-gradient(circle_at_top,_rgba(99,102,241,0.14),_transparent_55%)]" />
        <div className="relative mx-auto flex max-w-3xl flex-col items-center px-4 py-24 text-center sm:px-6 lg:py-32">
          <p className="text-sm font-semibold uppercase tracking-[0.28em] text-indigo-600">404</p>
          <h1 className="mt-4 text-4xl font-semibold tracking-tight text-slate-950 sm:text-5xl">Page not found</h1>
          <p className="mt-5 max-w-lg text-base leading-8 text-slate-600">
            The address may be mistyped, or the page may have been moved. Use the links below to get back to subscription
            support.
          </p>
          <div className="mt-10 flex flex-wrap items-center justify-center gap-4">
            <a
              href="/"
              className="inline-flex items-center gap-2 rounded-full bg-indigo-600 px-5 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-indigo-500"
            >
              <FiArrowLeft className="h-4 w-4" aria-hidden />
              Back to home
            </a>
            <a
              href="/faqs"
              className="inline-flex items-center gap-2 rounded-full border border-slate-300 bg-white px-5 py-2.5 text-sm font-semibold text-slate-700 transition hover:border-indigo-300 hover:text-indigo-600"
            >
              <FiHelpCircle className="h-4 w-4" aria-hidden />
              View FAQs
            </a>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
}
